import { ReactNode, ReactPortal } from 'react';
import * as ReactDOM from 'react-dom';
import { Dom } from '@team/dom';

export const createPortal = (
  children: ReactNode,
  container?: Element | DocumentFragment | null,
  key?: null | string
): ReactPortal => {
  const resolvedContainer = container ?? Dom.getDocumentBody();

  return ReactDOM.createPortal(children, resolvedContainer, key);
};
